import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const loadCheckout = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

export const payBookingAdvance = async ({ name = "", phone = "", leadId = "", termsAccepted = false, onSuccess, onFailure }) => {
  try {
    const loaded = await loadCheckout();
    if (!loaded) throw new Error("checkout_load_failed");
    const { data } = await axios.post(`${API}/payments/order`, {
      lead_id: leadId,
      name,
      phone,
      terms_accepted: termsAccepted,
    });
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      name: "Sharpin Healthcare Services",
      description: "Booking Advance — fully adjustable",
      order_id: data.order_id,
      prefill: { name, contact: phone },
      theme: { color: "#0D9488" },
      handler: async (response) => {
        try {
          await axios.post(`${API}/payments/verify`, {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          });
          onSuccess?.();
        } catch {
          onFailure?.();
        }
      },
    });
    rzp.open();
  } catch {
    onFailure?.();
  }
};
